<template>
    <v-list class="list-sidemenu">
        <v-list-item-group>
            <draggable
                draggable=".draggable"
                v-model="menusLocal"
                :options="draggableOptions"
                @end="updateOrder">
                <navigation-menu
                    v-for="menu in menusLocal"
                    :key="menu.id"
                    :name="menu.name"
                    :title="menu.title"
                    :icon-key="menu.iconKey"
                    :page-switch-key="menu.pageSwitchKey"
                    :draggable="true">
                </navigation-menu>
            </draggable>
            <navigation-menu
                v-if="portfolios && isMainCompany"
                :draggable="false"
                name="Portfolios"
                title="Portfolios"
                icon-key="mdi-file-chart"/>
            <navigation-menu
                :draggable="false"
                name="Newsletters"
                title="Newsletters"
                page-switch-key="newsletters_page"
                icon-key="mdi-newspaper"/>
            <navigation-menu
                :draggable="false"
                name="Vault"
                title="Vault"
                icon-key="mdi-file-lock"/>
            <navigation-menu
                :draggable="false"
                name="Reports"
                title="Reports"
                icon-key="mdi-file"/>
            <navigation-menu
                :draggable="false"
                name="Settings"
                title="Setting"
                icon-key="mdi-cogs"/>
            <navigation-menu
                :draggable="false"
                :custom="true"
                name="Settings"
                title="Setting"
                icon-key="mdi-file-lock">
                <template v-slot:component>
                    <logout
                        is-portal="true"></logout>
                </template>
            </navigation-menu>
        </v-list-item-group>
    </v-list>
</template>

<script>
import NavigationMenu from "@/components/NavigationMenu";
import draggable from 'vuedraggable';
import Logout from "@/components/Logout";
import {mapGetters, mapState} from 'vuex';

export default {
    components: {
        Logout,
        NavigationMenu,
        draggable
    },

    props: {
        draggableMenus: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            menusLocal: this.draggableMenus,
            draggableOptions: {
                delay: 500,
                delayOnTouchOnly: true
            }
        }
    },

    computed: {
        ...mapState('auth', ['portfolios']),
        ...mapGetters('company', ['isMainCompany']),
        order() {
            let ids = [];
            this.menusLocal.forEach((el) => ids.push(el.id));
            return ids;
        }
    },

    methods: {
        updateOrder() {
            this.$emit('navigationMenuOrderUpdated', {'portal_navigation_order': JSON.stringify(this.order)});
        }
    }

}
</script>
